<template>
  <span
    class="bm-chip"
    :class="`bm-chip--${meta.tone}`"
    :data-testid="testid"
    :data-status="status"
    :data-tone="meta.tone"
    :data-icon="meta.icon"
  >
    <i class="material-icons bm-chip__icon" aria-hidden="true">{{ meta.icon }}</i>
    <span class="bm-chip__label">{{ meta.label }}</span>
    <span v-if="gloss" class="bm-chip__gloss">&middot; {{ meta.gloss }}</span>
  </span>
</template>

<script>
/**
 * The batch status chip.
 *
 * `data-tone` carries the color rule into the DOM so it can be asserted
 * without a computed-style primitive. Amber is Holding and nothing else.
 */
import { statusMeta } from "./batchStatus";

export default {
  name: "BatchStatusChip",
  props: {
    status: { type: String, required: true },
    gloss: { type: Boolean, default: false },
    testid: { type: String, default: undefined },
    // release_blocked only: did a stranded order's card get charged?
    // true / false / null (not known yet). See statusMeta.
    moneyTaken: { type: Boolean, default: null },
    // release_blocked only: { notSent, total } when part of the batch WAS
    // sent. Scopes the gloss to counts; see statusMeta.
    partial: { type: Object, default: null },
  },
  computed: {
    meta() {
      return statusMeta(this.status, {
        moneyTaken: this.moneyTaken,
        partial: this.partial,
      });
    },
  },
};
</script>

<style scoped>
.bm-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 9999px;
  padding: 4px 12px 4px 9px;
  font-size: 12.5px;
  font-weight: 500;
  letter-spacing: 0.2px;
  white-space: nowrap;
  border: 1px solid transparent;
}

.bm-chip__icon {
  font-size: 15px;
  line-height: 1;
}

.bm-chip__gloss {
  font-weight: 400;
  opacity: 0.8;
}

.bm-chip--blue {
  background: var(--tf-chip-info-bg);
  color: var(--tf-chip-info-fg);
  border-color: var(--tf-chip-info-border);
}

/* Amber. The ONLY amber thing on this surface. */
.bm-chip--amber {
  background: var(--tf-chip-pending-bg);
  color: var(--tf-chip-pending-fg);
  border-color: var(--tf-chip-pending-border);
}

/* Released is inert: neutral, no call to action. */
.bm-chip--slate {
  background: var(--tf-surface-dark);
  color: var(--tf-fg-3);
  border-color: var(--tf-border-strong);
}

/* Red is reserved for Failed and destructive actions. */
.bm-chip--red {
  background: var(--tf-chip-error-bg);
  color: var(--tf-chip-error-fg);
  border-color: var(--tf-chip-error-border);
}

@media (max-width: 599px) {
  .bm-chip {
    padding: 2px 9px 2px 7px;
    font-size: 11.5px;
  }
}
</style>
